import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Badge,
  useColorModeValue,
  Button,
  Link,
  Image,
  HStack,
  Icon,
} from '@chakra-ui/react';
import { FaExternalLinkAlt, FaCheckCircle, FaUsers, FaGift } from 'react-icons/fa';
import schemesData from '../../data/governmentSchemes.json';
import { useTranslation } from '../../translations/useTranslation';

function GovernmentSchemes() {
  const cardBg = useColorModeValue('white', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const { t } = useTranslation();

  return (
    <Container maxW="container.xl" py={10}>
      <VStack spacing={8} align="stretch">
        <Box textAlign="center" mb={8}>
          <Heading as="h1" size="xl" color="green.600" mb={4}>
            {t('governmentAgriculturalSchemes')}
          </Heading>
          <Text fontSize="lg" color="gray.600">
            {t('exploreSchemes')}
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
          {schemesData.schemes.map((scheme) => (
            <Box
              key={scheme.name}
              bg={cardBg}
              p={6}
              borderRadius="lg"
              border="1px"
              borderColor={borderColor}
              shadow="md"
              transition="all 0.3s"
              _hover={{ transform: 'translateY(-5px)', shadow: 'lg' }}
            >
              <VStack align="stretch" spacing={4}>
                <Badge colorScheme="green" alignSelf="flex-start">
                  {scheme.year}
                </Badge>
                <Image
                  src={scheme.image}
                  alt={scheme.name}
                  borderRadius="md"
                  objectFit="cover"
                  height="200px"
                  width="100%"
                />
                <Heading as="h3" size="md">
                  {scheme.name}
                </Heading>
                <Text color="gray.600">
                  {scheme.description}
                </Text>
                
                <Box bg="green.50" p={4} borderRadius="md">
                  <VStack align="stretch" spacing={3}>
                    <HStack>
                      <Icon as={FaGift} color="green.500" />
                      <Text fontWeight="bold">{t('benefits')}:</Text>
                    </HStack>
                    <Text fontSize="sm" color="gray.600" pl={6}>
                      {scheme.benefits}
                    </Text>
                    
                    <HStack>
                      <Icon as={FaUsers} color="green.500" />
                      <Text fontWeight="bold">{t('eligibility')}:</Text>
                    </HStack>
                    <Text fontSize="sm" color="gray.600" pl={6}>
                      {scheme.eligibility}
                    </Text>
                  </VStack>
                </Box>

                <Button
                  as={Link}
                  href={scheme.official_link}
                  target="_blank"
                  colorScheme="green"
                  size="md"
                  rightIcon={<FaExternalLinkAlt />}
                  isExternal
                >
                  {t('applyNow')}
                </Button>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>

        <Box textAlign="center" mt={8} p={6} bg="green.50" borderRadius="lg">
          <VStack spacing={4}>
            <Icon as={FaCheckCircle} w={8} h={8} color="green.500" />
            <Heading as="h3" size="md" color="green.700">
              {t('source')}
            </Heading>
            <Text color="gray.600">
              {schemesData.meta.source}
            </Text>
            <Text fontSize="sm" color="gray.500">
              {t('lastUpdated')}: {schemesData.meta.last_updated}
            </Text>
          </VStack>
        </Box>
      </VStack>
    </Container>
  );
}

export default GovernmentSchemes;
